import React from 'react';

const PromptIcon = (props) => {
  return (
    <svg {...props} id="prompt-icon" width="700" height="700" viewBox="0 0 700 700" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M200 240C200 217.909 217.909 200 240 200H460C482.091 200 500 217.909 500 240V460C500 482.091 482.091 500 460 500H240C217.909 500 200 482.091 200 460V240Z" fill="white"/>
    <path d="M200 240C200 217.909 217.909 200 240 200H460C482.091 200 500 217.909 500 240V460C500 482.091 482.091 500 460 500H240C217.909 500 200 482.091 200 460V240Z" fill="#F2F2F2"/>
    <path d="M700 600V100C700 44.85 655.15 0 600 0H100C44.85 0 0 44.85 0 100V600C0 655.15 44.85 700 100 700H600C655.15 700 700 655.15 700 600ZM100 100H600L600.1 600H100V100Z" fill="#E5E301"/>
    </svg>
  );
}


export { PromptIcon };
